import { ReactComponent as Loader } from './loader.svg';
import './buttonloader.css';
import { useNavigate } from 'react-router-dom';

export const ButtonLoader = ({ onSubmit, text,style={backGroundColor:'lightgray',fontSize:'medium',color:'black'}, loading = false, disabled }) => {
  return (
    <button style={{background:style.backGroundColor,fontSize:style.fontSize,color:style.color}} className="submit-btn" onClick={onSubmit} disabled={disabled}>
      {!loading ? text : <Loader className="spinner" />}
    </button>
  )
};

export const TeachButton = ({target,id,width='100%',height=40})=>
{

  const navigator = useNavigate();
  return(
    <button onClick={e=>{navigator(`/learning/${target}/${id}`);}} style={{margin:'10px',height:height.toString()+'px',width:'fit-content',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:'lightgray'}} type='button' value={"Que dois-je savoir"} >
      <img src='/images/icons/rikinaze.jpeg' style={{height:(height-10).toString()+'px',width:'30px', borderRadius:'15px', display:'inline-block',verticalAlign:'middle'}} />
      <label style={{display:'inline-block',verticalAlign:'middle',marginLeft:'10px'}}>Que dois-je savoir ?</label>
    </button>
  )
}